import React, {useEffect} from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import {Link} from "react-router-dom";
import {Helmet} from "react-helmet";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import { Typography } from '@mui/material';
import {makeStyles} from "@material-ui/core/styles";
import wallPaper from "../assets/static/images/bicc-about-us.png";
import {data} from "./configs/AboutData";
import liveinCare from "../assets/static/images/rev-leodah-gray.jpg"
import supportedLiving from '../assets/static/images/rev-ncube-gray.jpg'
import evangelist from '../assets/static/images/evangelist.png'
import decon from '../assets/static/images/decon-gray.jpg'
import {sectionOne, sectionTwo} from "./configs/ServicesData";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
  heroContent: {
    padding: theme.spacing(14, 0, 6),
    backgroundImage: `url(${wallPaper})`,
    backgroundColor: 'rgba(0, 0, 0, 0.13)',
    backgroundBlendMode: 'darken',
    backgroundSize: 'cover'
  },
  sections: {
  },
  sectionTitles: {
    paddingBottom: '30px',
    fontWeight: 'bolder',
    paddingTop: '64px',
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  cardTitle: {
    fontWeight: 'bold',
    paddingBottom: '25px'
  },
    cardContentText: {
      paddingBottom: '20px',
      fontWeight: 'bold'
    },
    card: {
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '0 12px 24px 0 rgba(0,0,0,0.08)'
    },
    cardMedia: {
      paddingTop: '56.25%', // 16:9
      marginBottom: '15px',
    },
    cardContent: {
      flexGrow: 1,
    },
  coreValues: {
    fontWeight: 'bold'
  }
}));


export default function About(props) {

  const classes = useStyles();

  useEffect(() => {

  }, [])

  return (
  <React.Fragment>
    <Helmet>
    <meta name="description"
          content="Leeds BICC - Proudly Serving The Lord" />
    <title>Leeds Brethren In Christ Churh</title>
    </Helmet>
    <CssBaseline />
    <main>
    {/* Hero unit */}
    <div className={classes.heroContent}>
    <Breadcrumb>
      <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
      <BreadcrumbItem active>About</BreadcrumbItem>
    </Breadcrumb>
      <Container maxWidth="sm">
        <Typography
          component="h1"
          variant="h4"
          align="center"
          color="textPrimary"
          style={{fontWeight: 'bold', color: 'white'}}
          gutterBottom>
          <span className="page-header">About</span>
        </Typography>
      </Container>
    </div>
    </main>
    <div>
      <div className={classes.sections}>
        <Container maxWidth="md">
          <Typography
          component="h1"
          variant="h5"
          align="center"
          color="textPrimary"
          className={classes.sectionTitles}
          gutterBottom>
            Who we are
          </Typography>
          <Typography>
            {data.whoWeAre}
          </Typography>
        </Container>
      </div>
      <div className={classes.sections}>
        <Container maxWidth="md">
          <Typography
          component="h1"
          variant="h5"
          align="center"
          color="textPrimary"
          className={classes.sectionTitles}
          gutterBottom>
            About Us
          </Typography>
          <Typography>
            {data.aboutUs}
          </Typography>
        </Container>
      </div>
      {/*<div className={classes.sections}>*/}
      {/*  <Container maxWidth="md">*/}
      {/*    <Typography*/}
      {/*      component="h1"*/}
      {/*      variant="h5"*/}
      {/*      align="center"*/}
      {/*      color="textPrimary"*/}
      {/*      className={classes.sectionTitles}*/}
      {/*      gutterBottom>*/}
      {/*      Pastoral Team*/}
      {/*    </Typography>*/}
      {/*    <Grid container spacing={3}>*/}
      {/*      <Grid item xs={12} sm={6}>*/}
      {/*        <Card className={classes.card} >*/}
      {/*          <CardMedia*/}
      {/*              className={classes.cardMedia}*/}
      {/*              image={supportedLiving}*/}
      {/*              title="Leeds BICC"*/}
      {/*          />*/}
      {/*          <CardContent className={classes.cardContent}>*/}
      {/*            <Typography gutterBottom variant="h5" component="h2" className={classes.cardTitle}>*/}
      {/*                {sectionOne.cardOneTitle}*/}
      {/*            </Typography>*/}
      {/*            {sectionOne.cardOneDesc.map((text, index) => (*/}
      {/*              <div className={classes.cardContentText}>*/}
      {/*                <Typography*/}
      {/*                    className={index === 0 || text.startsWith('“') ? 'title-text': 'default-text'}*/}
      {/*                >*/}
      {/*                    {text}*/}
      {/*                </Typography>*/}
      {/*              </div>*/}
      {/*            ))*/}
      {/*            }*/}
      {/*          </CardContent>*/}
      {/*          <CardActions style={{marginBottom: '20px', alignItems: 'center', justifyContent: 'center'}}>*/}
      {/*              /!*<Button size="small" variant="contained" color="secondary" onClick={() => handleButtonClick()}>*!/*/}
      {/*              /!*    Contact*!/*/}
      {/*              /!*</Button>*!/*/}
      {/*          </CardActions>*/}
      {/*          </Card>*/}
      {/*      </Grid>*/}
      {/*      <Grid item xs={12} sm={6}>*/}
      {/*        <Card className={classes.card} >*/}
      {/*          <CardMedia*/}
      {/*              className={classes.cardMedia}*/}
      {/*              image={liveinCare}*/}
      {/*              title="Leeds BICC"*/}
      {/*          />*/}
      {/*          <CardContent className={classes.cardContent}>*/}
      {/*            <Typography gutterBottom variant="h5" component="h2" className={classes.cardTitle}>*/}
      {/*                {sectionOne.cardTwoTitle}*/}
      {/*            </Typography>*/}
      {/*            {sectionOne.cardTwoDesc.map((text, index) => (*/}
      {/*              <div className={classes.cardContentText}>*/}
      {/*                <Typography*/}
      {/*                className={index === 0 || text.startsWith('“') ? 'title-text': 'default-text'}*/}
      {/*                >*/}
      {/*                    {text}*/}
      {/*                </Typography>*/}
      {/*              </div>*/}
      {/*            ))*/}
      {/*            }*/}
      {/*          </CardContent>*/}
      {/*          <CardActions style={{marginBottom: '20px', alignItems: 'center', justifyContent: 'center'}}>*/}
      {/*            /!*<Button size="small" variant="contained" color="secondary">*!/*/}
      {/*            /!*    Contact*!/*/}
      {/*            /!*</Button>*!/*/}
      {/*          </CardActions>*/}
      {/*          </Card>*/}
      {/*      </Grid>*/}
      {/*    </Grid>*/}
      {/*  </Container>*/}
      {/*</div>*/}
    </div>
  </React.Fragment>
  );
}